export class OfferingModal extends HTMLElement {
  content = this.querySelector(".offering-content")

  constructor() {
    super()

    this.classList.add(
      "hidden",
      "fixed",
      "flex-col",
      "justify-center",
      "items-center",
      "inset-0",
      "z-[1001]",
      "bg-black",
      "bg-opacity-50",
      "opacity-0",
      "transition-opacity"
    )

    this.content?.classList.add("transition-transform", "translate-y-full")

    const closeButton = this.querySelector<HTMLButtonElement>("button#close")

    if (closeButton == null) {
      throw new Error(`Missing close button implementation`)
    }

    closeButton.addEventListener("click", () => this.close())
  }

  show() {
    this.classList.replace("hidden", "flex")
    setTimeout(() => {
      this.classList.replace("opacity-0", "opacity-100")
      this.content?.classList.replace("translate-y-full", "translate-y-0")
    }, 10)
  }

  close() {
    this.classList.replace("opacity-100", "opacity-0")
    this.content?.classList.replace("translate-y-0", "translate-y-full")

    setTimeout(() => {
      this.classList.replace("flex", "hidden")
      const clone = this.cloneNode(true)
      this.parentElement?.appendChild(clone)
      this.parentElement?.removeChild(this)
    }, 100)
  }
}

customElements.define("offering-modal", OfferingModal)
